import { useTranslation } from 'react-i18next';
import { Menu as MenuIcon, Plus, Search } from 'lucide-react';
import { Logo } from '@vatman/ui';
import { CreateMenu } from './CreateMenu';
import { openQuickOpen } from './QuickOpen';
import { setNavDrawer, useNav } from './navState';
import '../shell.css';

/**
 * The top of a page on a phone, where the sidebar is hidden: the menu button that slides the
 * sidebar in over the page (navState.ts closes it on the backdrop, on Escape, or when a link in it
 * took the person elsewhere), search and "Create". Hidden on wider screens.
 */
export function MobileBar() {
  const { t } = useTranslation();
  const open = useNav((s) => s.drawer);
  return (
    <div className="mobile-bar">
      <button className="nav-burger" aria-label={t('nav.menu')} aria-expanded={open} onClick={() => setNavDrawer(!open)}>
        <MenuIcon size={18} />
      </button>
      <Logo size={26} />
      <span className="mobile-bar-gap" />
      <button className="icon-btn" aria-label={t('quickOpen.button')} onClick={() => openQuickOpen()}>
        <Search size={18} />
      </button>
      <CreateMenu align="end">
        <button className="icon-btn" aria-label={t('create.title')}>
          <Plus size={18} />
        </button>
      </CreateMenu>
    </div>
  );
}
